// extracted by mini-css-extract-plugin
export default {"content":"login-message-dialog_content__Qqo7z","btn":"login-message-dialog_btn__0+ggl"};